import { render, staticRenderFns } from "./ApprovalConfigurationInstanceDetailUpload.vue?vue&type=template&id=7b99f1d6&"
import script from "./ApprovalConfigurationInstanceDetailUpload.vue?vue&type=script&lang=js&"
export * from "./ApprovalConfigurationInstanceDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports